var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { key: _vm.shipment._id || 1, staticClass: "mb-5" }, [
    _c(
      "ul",
      {
        staticClass: "list-group list-group-flush modal-body-fixed-footer",
        attrs: { "data-title": "Shipment Form" },
      },
      [
        _vm.allPoList.length
          ? _c(
              "li",
              { staticClass: "list-group-item py-5" },
              [
                _c("h5", [_vm._v("Purchase Orders")]),
                _c("autocomplete-input", {
                  attrs: {
                    placeholder: "Select Po(s)...",
                    optionsV: _vm.allPoListOptions,
                    multiple: true,
                    isObject: true,
                    outValKey: true,
                    label: "friendlyPurchaseOrderDetailId",
                    "track-by": "friendlyPurchaseOrderDetailId",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (props) {
                          return [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        props.option
                                          .friendlyPurchaseOrderDetailId
                                      )
                                    ),
                                  ]),
                                  props.option?.supplierName
                                    ? _c("span", { staticClass: "ml-2" }, [
                                        _vm._v(
                                          "(" +
                                            _vm._s(props.option?.supplierName) +
                                            ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                  props.option?.shipmentId
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "badge badge-success ml-2",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(props.option.shipmentId)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3889300785
                  ),
                  model: {
                    value: _vm.shipment.poIds,
                    callback: function ($$v) {
                      _vm.$set(_vm.shipment, "poIds", $$v)
                    },
                    expression: "shipment.poIds",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.shipment.fobPoint
          ? _c(
              "li",
              { staticClass: "list-group-item py-5" },
              [
                _c("h5", [_vm._v("From")]),
                _c("div", { staticClass: "row" }, [
                  !_vm.shipment.fobPoint.formVisible &&
                  ((_vm.purchaseOrder && _vm.purchaseOrder.supplier) ||
                    _vm.allPoList.length)
                    ? _c(
                        "div",
                        { staticClass: "col-md-8" },
                        [
                          _c("autocomplete-input", {
                            attrs: {
                              path:
                                "/fobPoints?fields=city&fields=state&fields=zip",
                              name: "FobPoint",
                              loadOnFocus: "",
                              isObject: "",
                              "track-by": "_id",
                              query: _vm.autocompleteQuery,
                              internalSearch: false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            [
                                              props.option.city,
                                              props.option.state,
                                              props.option.zip,
                                            ]
                                              .filter((e) => e)
                                              .join(", ") ||
                                              props.option.fobId ||
                                              ""
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [
                                          _vm._v(
                                            _vm._s(props.option.fobId || "NA")
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "singleLabel",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            [
                                              props.option.city,
                                              props.option.state,
                                              props.option.zip,
                                            ]
                                              .filter((e) => e)
                                              .join(", ") ||
                                              props.option.fobId ||
                                              ""
                                          ) +
                                          "\n              "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [
                                          _vm._v(
                                            _vm._s(props.option.fobId || "NA")
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1246300790
                            ),
                            model: {
                              value: _vm.shipment.fobPointId,
                              callback: function ($$v) {
                                _vm.$set(_vm.shipment, "fobPointId", $$v)
                              },
                              expression: "shipment.fobPointId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("validated-input", {
                        attrs: {
                          label: "Quantity",
                          validate: {
                            required: _vm.shippingRequired,
                            min_value: _vm.shippingRequired ? 1 : 0,
                          },
                          mode: "instant",
                        },
                        model: {
                          value: _vm.shipment.Quantity.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.shipment.Quantity, "value", $$v)
                          },
                          expression: "shipment.Quantity.value",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleFobFormVisibility()
                      },
                    },
                  },
                  [_vm._v("Add Fob Point")]
                ),
                _c(
                  "b-collapse",
                  {
                    staticClass: "mt-2",
                    attrs: { id: "collapse-1" },
                    model: {
                      value: _vm.shipment.fobPoint.formVisible,
                      callback: function ($$v) {
                        _vm.$set(_vm.shipment.fobPoint, "formVisible", $$v)
                      },
                      expression: "shipment.fobPoint.formVisible",
                    },
                  },
                  [
                    _c("label", [_vm._v("Fob Id")]),
                    _c("b-form-input", {
                      attrs: { name: "fobId" },
                      model: {
                        value: _vm.shipment.fobPoint.fobId,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment.fobPoint, "fobId", $$v)
                        },
                        expression: "shipment.fobPoint.fobId",
                      },
                    }),
                    _c("address-fields", {
                      attrs: { hide: ["street2"] },
                      model: {
                        value: _vm.shipment.fobPoint,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment, "fobPoint", $$v)
                        },
                        expression: "shipment.fobPoint",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("li", { staticClass: "list-group-item py-5" }, [
          _c("h5", [_vm._v("To")]),
          _c("div", [
            _c("div", {}, [
              _c(
                "div",
                { staticClass: "mt-3 card p-3" },
                [
                  _c(
                    "b-form-group",
                    {},
                    [
                      _c(
                        "b-form-radio-group",
                        {
                          staticClass: "m-0 d-flex justify-content-between",
                          model: {
                            value: _vm.shipment.access,
                            callback: function ($$v) {
                              _vm.$set(_vm.shipment, "access", $$v)
                            },
                            expression: "shipment.access",
                          },
                        },
                        [
                          _c("b-form-radio", { attrs: { value: "Customer" } }, [
                            _vm._v(
                              "\n                  Customer\n                  "
                            ),
                            _c("i", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "fas fa-question-circle ml-1 text-light",
                              attrs: { title: `Shipment is to customer.` },
                            }),
                          ]),
                          _c(
                            "b-form-radio",
                            { attrs: { value: "Decorator" } },
                            [
                              _vm._v(
                                "\n                  Decorator\n                  "
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass:
                                  "fas fa-question-circle ml-1 text-light",
                                attrs: { title: `Shipment is to a decorator.` },
                              }),
                            ]
                          ),
                          _c(
                            "b-form-radio",
                            { attrs: { value: "Distributor" } },
                            [
                              _vm._v(
                                "\n                  Distributor\n                  "
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass:
                                  "fas fa-question-circle ml-1 text-light",
                                attrs: {
                                  title: `Shipment is to a distributor.  Shipment updates will not be shown to customer.`,
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("autocomplete-input", {
                    key: _vm.shipment.access,
                    attrs: {
                      path:
                        (_vm.shipment.access === "Decorator" &&
                          "/distributors/-1/supplier-decorators/addresses") ||
                        "",
                      loadOnFocus: "",
                      isObject: "",
                      "track-by": "_id",
                      "internal-search": false,
                      "only-search": true,
                      filterOptions:
                        (_vm.shipment.access === "Customer" &&
                          _vm.filterCustomerAddresses) ||
                        null,
                      "options-v": _vm.addressOptions,
                      placeholder: "Saved addresses...",
                    },
                    on: { select: _vm.selectAddress },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function (props) {
                          return [
                            _c(
                              "div",
                              {},
                              [
                                props.option.description
                                  ? _c("h6", [
                                      _vm._v(_vm._s(props.option.description)),
                                    ])
                                  : _vm._e(),
                                _c("AddressFormat", {
                                  staticClass: "small",
                                  attrs: { address: props.option, list: true },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "singleLabel",
                        fn: function (props) {
                          return [
                            props.option
                              ? _c(
                                  "div",
                                  { staticClass: "pt-0 pb-0" },
                                  [
                                    props.option.description
                                      ? _c("h6", [
                                          _vm._v(
                                            _vm._s(props.option.description)
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c("AddressFormat", {
                                      staticClass: "small",
                                      attrs: {
                                        address: props.option,
                                        list: true,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selectedAddress,
                      callback: function ($$v) {
                        _vm.selectedAddress = $$v
                      },
                      expression: "selectedAddress",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "my-3", attrs: { id: "collapseShippingAddress" } },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex mb-3 flex-column" },
                      [
                        _c("validated-input", {
                          attrs: {
                            label: "Contact",
                            validate: { required: true },
                          },
                          model: {
                            value: _vm.shipment.contactName,
                            callback: function ($$v) {
                              _vm.$set(_vm.shipment, "contactName", $$v)
                            },
                            expression: "shipment.contactName",
                          },
                        }),
                        _c(
                          "a",
                          {
                            staticClass: "small",
                            staticStyle: { "margin-top": "-18px" },
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addContact.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Auto populate")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex mb-3 flex-column" },
                      [
                        _c("validated-input", {
                          attrs: { label: "Company" },
                          model: {
                            value: _vm.shipment.companyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.shipment, "companyName", $$v)
                            },
                            expression: "shipment.companyName",
                          },
                        }),
                        _c(
                          "a",
                          {
                            staticClass: "small",
                            staticStyle: { "margin-top": "-18px" },
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addCompany.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("Auto populate")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _c("address-fields", {
                  attrs: {
                    "is-city-required": _vm.shippingRequired,
                    "is-state-required": _vm.stateRequired,
                    "is-country-required": _vm.shippingRequired,
                    "is-zip-required": _vm.shippingRequired,
                    hide: ["addressName"],
                  },
                  model: {
                    value: _vm.shipment,
                    callback: function ($$v) {
                      _vm.shipment = $$v
                    },
                    expression: "shipment",
                  },
                }),
                _vm.shipment.access !== "Decorator"
                  ? _c(
                      "b-form-checkbox",
                      {
                        staticClass: "my-1",
                        model: {
                          value: _vm.shipment.saveAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.shipment, "saveAddress", $$v)
                          },
                          expression: "shipment.saveAddress",
                        },
                      },
                      [_vm._v("Save Address")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm.shipment.shipReferences
          ? _c(
              "li",
              { staticClass: "list-group-item py-5" },
              [
                _c("h5", [_vm._v("References Fields")]),
                _c("validated-input", {
                  attrs: { label: "Field 1", validate: { required: false } },
                  model: {
                    value: _vm.shipment.shipReferences.referenceField1,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.shipment.shipReferences,
                        "referenceField1",
                        $$v
                      )
                    },
                    expression: "shipment.shipReferences.referenceField1",
                  },
                }),
                _c("validated-input", {
                  attrs: { label: "Field 2", validate: { required: false } },
                  model: {
                    value: _vm.shipment.shipReferences.referenceField2,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.shipment.shipReferences,
                        "referenceField2",
                        $$v
                      )
                    },
                    expression: "shipment.shipReferences.referenceField2",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "li",
          { staticClass: "list-group-item py-5" },
          [
            _c("h5", [_vm._v("Packages")]),
            [
              _vm.tryCategoryShipment
                ? _c("div", { staticClass: "text-danger py-3" }, [
                    _c("i", {
                      staticClass: "far fa-exclamation-triangle mr-2",
                    }),
                    _vm._v(
                      "\n          Shipping dimensions provided from supplier might be incorrect. If they seem off we recommend\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { disabled: _vm.loadingDimension },
                        on: { click: _vm.useCategoryDimension },
                      },
                      [_vm._v(" using category part dimensions ")]
                    ),
                    _vm._v(
                      " which\n          averages dimensions across all products associated with this products category.\n        "
                    ),
                  ])
                : _vm._e(),
              !_vm.shipment.width ||
              !_vm.shipment.height ||
              !_vm.shipment.depth ||
              !_vm.shipment.weight ||
              !_vm.shipment.numberOfPackages
                ? _c("div", { staticClass: "mb-3" }, [
                    _c(
                      "a",
                      {
                        attrs: { disabled: _vm.loadingDimension },
                        on: { click: _vm.useCategoryDimension },
                      },
                      [_vm._v(" Use category shipping dimensions ")]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "row d-flex align-items-center" },
                [
                  _vm._l(_vm.dimensionFields, function (field, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-4" },
                      [
                        _c("validated-input", {
                          attrs: {
                            type: "number",
                            label: field.label,
                            value: _vm.shipment[field.name],
                            validate: {
                              min_value: _vm.shippingRequired
                                ? field.minValue
                                : 0,
                              required: _vm.shippingRequired,
                            },
                            placeholder: field.placeholder,
                          },
                          on: {
                            input: (val) =>
                              _vm.updateDimensionField(field.name, val),
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "col-4 text-right" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover",
                            value: {
                              content: `Calculate shipping`,
                              html: true,
                            },
                            expression:
                              "{\n                content: `Calculate shipping`,\n                html: true\n              }",
                            modifiers: { hover: true },
                          },
                        ],
                        key: _vm.watchProps,
                        staticClass: "btn btn-secondary btn-block mt-2",
                        attrs: { disabled: !_vm.loaded || !!_vm.error },
                        on: { click: _vm.loadRates },
                      },
                      [_c("i", { staticClass: "fas fa-calculator" })]
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  !_vm.loaded
                    ? _c("div", { staticClass: "text-center" }, [
                        _c("i", {
                          staticClass:
                            "far fa-spinner-third fa-spin fa-2x text-primary",
                        }),
                      ])
                    : _vm.error
                    ? _c(
                        "div",
                        { staticClass: "invalid-feedback d-block pt-2" },
                        [
                          _c(
                            "b-alert",
                            { attrs: { variant: "danger", show: "" } },
                            [_vm._v(_vm._s(_vm.error))]
                          ),
                        ],
                        1
                      )
                    : _c("ShippingRatesDropdown", {
                        key: _vm.labelUpdated,
                        attrs: {
                          productId: _vm.productId,
                          shipment: _vm.shipment,
                          fobPointId:
                            (_vm.fobPointId || _vm.shipment.fobPointId || {})
                              ._id ||
                            _vm.fobPointId ||
                            _vm.shipment.fobPointId,
                          supplierCode: _vm.supplierCode,
                          purchaseOrder: _vm.purchaseOrder,
                          rates: _vm.rates,
                          value: _vm.rate,
                        },
                        on: { input: _vm.chooseRate, onSave: _vm.onSave },
                      }),
                ],
                1
              ),
            ],
          ],
          2
        ),
        _c(
          "li",
          { staticClass: "list-group-item py-5" },
          [
            _c("h5", [_vm._v("Carrier")]),
            _c("ShipmentFormCarriers", {
              attrs: { shipment: _vm.shipment, order: _vm.purchaseOrder.order },
              on: { select: _vm.select },
            }),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("ShipmentCarierInput", {
                      attrs: { required: _vm.shippingRequired },
                      model: {
                        value: _vm.shipment.carrier,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment, "carrier", $$v)
                        },
                        expression: "shipment.carrier",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("validated-input", {
                      attrs: {
                        label: "Service",
                        validate: { required: _vm.shippingRequired },
                      },
                      model: {
                        value: _vm.shipment.carrierService,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment, "carrierService", $$v)
                        },
                        expression: "shipment.carrierService",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("validated-input", {
                      attrs: { label: "Account Name" },
                      model: {
                        value: _vm.shipment.thirdPartyAccountName,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment, "thirdPartyAccountName", $$v)
                        },
                        expression: "shipment.thirdPartyAccountName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("validated-input", {
                      attrs: { label: "Account Number" },
                      model: {
                        value: _vm.shipment.thirdPartyAccountNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.shipment, "thirdPartyAccountNumber", $$v)
                        },
                        expression: "shipment.thirdPartyAccountNumber",
                      },
                    }),
                  ],
                  1
                ),
                _vm._l(_vm.priceFields, function (field, index) {
                  return _c("div", { key: index, staticClass: "col-4" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("validated-input", {
                          attrs: {
                            label: field.label,
                            append: field.append,
                            validate: {
                              decimal: true,
                              required: _vm.shippingRequired,
                            },
                          },
                          on: {
                            input: (e) => _vm.updatePriceField(field.name, e),
                            blur: (e) =>
                              field.onBlur(_vm.shipment, field.blurParams),
                          },
                          model: {
                            value: _vm.shipment[field.name],
                            callback: function ($$v) {
                              _vm.$set(_vm.shipment, field.name, $$v)
                            },
                            expression: "shipment[field.name]",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                }),
              ],
              2
            ),
            _vm.shipmentCarrierValidationError
              ? _c(
                  "div",
                  { staticClass: "alert alert-danger text-wrap small" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.shipmentCarrierValidationError) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        !_vm.hidePackages
          ? _c(
              "li",
              { staticClass: "list-group-item py-5" },
              [
                _vm._m(0),
                _c("TrackingPackageList", {
                  attrs: {
                    order: this.purchaseOrder?.order,
                    trackingDetails: _vm.shipment,
                    "order-id": parseFloat(_vm.$route.params.orderId),
                    poIds: _vm.shipment.poIds,
                    shipment: _vm.shipment,
                    "po-number": _vm.poNumber,
                  },
                }),
                _c("EmailTracking", {
                  attrs: {
                    trackingDetails: _vm.trackingDetails,
                    customer: this.purchaseOrder?.order?.customerId,
                    order: this.purchaseOrder?.order,
                    poNumber: _vm.poNumber,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "li",
          { staticClass: "list-group-item py-5" },
          [
            _c("div", { staticClass: "d-flex align-items-center mb-2" }, [
              _c("h5", [_vm._v("Shipment Documents")]),
              _c("i", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.hover",
                    value: {
                      content:
                        "You need to save the Purchase Order with shipment before uploading shipment documents.",
                    },
                    expression:
                      "{\n            content: 'You need to save the Purchase Order with shipment before uploading shipment documents.'\n          }",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "fas fa-question-circle text-light ml-2",
              }),
            ]),
            _c("OrderDocuments", {
              attrs: {
                type: _vm.ORDER_DOCUMENT_TYPES.SHIPMENT_LABEL,
                params: { orderId: _vm.$route.params.orderId },
                documents: _vm.shipment.Documents,
              },
              on: {
                successOrderUpload: _vm.successOrderUpload,
                deleteOrderDocument: _vm.deleteOrderDocument,
              },
            }),
          ],
          1
        ),
        _vm.showAccounting
          ? _c(
              "li",
              { staticClass: "list-group-item" },
              [
                _c("accounting-dropdowns", {
                  attrs: {
                    value: _vm.shipment,
                    qbAccounts: _vm.qbAccounts,
                    poInvoices: _vm.purchaseOrder.invoices,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
    !_vm.hidePackages
      ? _c(
          "div",
          { staticClass: "card-footer modal-fixed-footer p-3" },
          [
            _c(
              "b-button",
              {
                staticClass: "m-1",
                attrs: {
                  variant: "primary",
                  disabled: _vm.loading || _vm.errors.any(),
                },
                on: { click: _vm.onSubmit },
              },
              [
                _vm._v("Save Shipment "),
                _vm.loading
                  ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                  : _vm._e(),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex" }, [
      _c("h5", [_vm._v("Tracking")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }